import { ENV } from '../lib/firebase'

// A loud, non-interactive marker shown only in non-production builds, so the sandbox can
// never be mistaken for prod. Pure overlay: pointer-events-none, so it never blocks the UI
// and doesn't disturb the single-screen layouts. Rendered app-wide from App.jsx when IS_DEV.
export default function DevBanner() {
  return (
    <>
      {/* Amber ring around the whole viewport */}
      <div aria-hidden className="pointer-events-none fixed inset-0 z-[9998] border-[3px] border-amber-500/80" />
      {/* Labeled pill, top-center */}
      <div
        aria-hidden
        className="pointer-events-none fixed top-0 left-1/2 -translate-x-1/2 z-[9999] flex items-center gap-1.5
          bg-amber-500 text-black text-[11px] font-bold uppercase tracking-wide px-3 py-0.5 rounded-b-md shadow-md"
      >
        ⚠ DEV Sandbox · {ENV} · not production
      </div>
    </>
  )
}
